<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-12">
          <p>
            Use the following to create/manage views with selected columns for
            customizing the coach listing.
          </p>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <div class="input-group">
            <span class="input-group-text">view</span>
            <input
              ref="inputAddView"
              class="form-control"
              v-if="isAdd"
              v-model="view"
              placeholder="enter new view name"
              @blur="updateView"
            />
            <select
              v-else
              class="form-select"
              v-model="view"
              @change="selectView"
            >
              <option v-for="(view, idx) of customViews" :key="idx">
                {{ view.name }}
              </option>
            </select>
            <button class="btn btn-link" @click="addView">
              <i class="fas fa-plus"></i>
            </button>
            <button
              v-if="showDelete"
              class="btn btn-link"
              @click="confirmRemove"
            >
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>
      <div class="row mb-2">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <div class="input-group">
            <span class="input-group-text">add column</span>
            <select v-model="column" class="form-select">
              <option
                v-for="column of availableColumns"
                :value="column"
                :key="column.id"
              >
                {{ column.name }}
              </option>
            </select>
            <button class="btn btn-link" @click="addColumn">
              <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>
      <div class="custom-table">
        <z-table
          :value="selectedColumns"
          sortOn="id"
          sortDir="asc"
          :isSingleRowDetail="false"
          :columns="tableColumns"
          class="table table-bordered table-striped"
        >
          <template v-slot:tbody="props">
            <td>{{ props.row.name }}</td>
            <td
              class="custom-column-60"
              @mouseenter="showSpin = props.row.id"
              @mouseleave="showSpin = null"
            >
              <z-stepper
                v-if="showSpin === props.row.id"
                @clickUp="stepperClickedUp(props.row.id)"
                @clickDown="stepperClickedDown(props.row.id)"
              />
            </td>
            <td class="custom-column-60">
              <a href="#" @click="removeColumn(props.row)">remove</a>
            </td>
          </template>
        </z-table>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button
              class="btn btn-primary me-2"
              :class="{ 'btn-danger': isHighlight }"
              @click="performSave(false)"
            >
              Save
            </button>
            <button
              class="btn btn-primary me-2"
              :class="{ 'btn-danger': isHighlight }"
              @click="performSave(true)"
            >
              Save and Close
            </button>
            <button
              type="button"
              class="btn btn-secondary me-2"
              @click="confirmCancel"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
  <confirm-cancel
    :show="actionCancel"
    confirmTitle="Unsaved Changes"
    confirmAction="Yes, Cancel"
    confirmQuestion="You have unsaved changes, are you sure you wish to cancel?"
    @closing="closeCancel"
    @proceed="performCancel"
  />
  <confirm-remove
    :show="actionRemove"
    confirmTitle="Remove View"
    confirmAction="Yes, Remove"
    confirmQuestion="Are you sure you wish to remove this View?"
    @closing="closeRemove"
    @proceed="performRemove"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZStepper from '@/Components/ZElements/Stepper'
import ZTable from '@/Components/ZElements/Table'
import ZSelect from '@/Components/ZElements/Select'
import ConfirmCancel from '@/Components/ZElements/ConfirmDialog'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
export default {
  name: 'custom-view-dialog',
  components: {
    ZDialog,
    ZStepper,
    ZTable,
    ZSelect,
    ConfirmCancel,
    ConfirmRemove,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      showSpin: null,
      sortChanged: false,
      column: null,
      isHighlight: false,
      isAdd: false,
      showDelete: false,
      actionCancel: null,
      actionRemove: null,
    }
  },
  mounted() {
    this.isAdd = false
    this.showDelete = false
    this.isHighlight = false
    this.getCustomViews()
  },
  emits: ['close', 'saved', 'cancel'],
  computed: {
    ...mapGetters('usercardio', ['columns', 'selectedView', 'customViews']),
    ...mapGetters('dashboardComponents', ['dashboardComponents']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = ''
      if (this.show) {
        _title = this.show.title
      }
      return _title
    },
    tableColumns() {
      return [
        {
          field: 'name',
          label: 'Name',
          sortable: false,
        },
        {
          field: 'order',
          label: 'sort',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
    view: {
      get() {
        let _data = null
        if (this.selectedView) {
          _data = this.selectedView.name
        }
        return _data
      },
      set(value) {
        console.log('Set Selected View', value)
        this.setSelectedView({ name: value, isAdd: this.isAdd })
      },
    },
    views() {
      let _views = []
      let _cnt = 0
      this.customViews.forEach((view) => {
        _views.push({
          id: _cnt,
          name: view.name,
        })
        _cnt++
      })
      return _views
    },
    availableColumns() {
      let _columns = JSON.parse(JSON.stringify(this.columns))
      if (this.dashboardComponents) {
        let cnt = 15
        this.dashboardComponents.forEach((element) => {
          _columns.push({
            id: cnt,
            name: element.name,
            code: `Component${element.id}`,
            order: 'asc',
            sort: cnt,
          })
          cnt++
        })
      }
      return _columns
    },
    selectedColumns() {
      let _columns = []
      if (this.selectedView) {
        _columns = this.selectedView.columns
      }
      console.log('Selected Columns', _columns)
      return _columns
    },
  },
  methods: {
    ...mapActions('usercardio', [
      'setCustomColumn',
      'getCustomViews',
      'setSelectedView',
      'updateCustomView',
      'saveCustomViews',
    ]),
    closeCancel() {
      this.actionCancel = null
    },
    closeRemove() {
      this.actionRemove = null
    },
    selectView() {
      this.selectedColumns = []
      this.showDelete = true
      this.isAdd = false
      this.isHighlight = false
      console.log('Selected a View', {
        view: this.view,
      })
    },
    addColumn() {
      if (this.view !== '') {
        if (this.column) {
          let data = {
            name: 'add',
            value: this.column,
            direction: null,
            view: this.view,
          }
          console.log('Adding Column 2', data)
          this.setCustomColumn(data)
          this.isHighlight = true
        } else {
          alert('Please supply a Column Name')
        }
      } else {
        alert('Please supply a View Name')
      }
    },
    removeColumn(row) {
      let data = {
        name: 'remove',
        value: row,
        direction: null,
        view: this.view,
      }
      console.log('Removing Column', data)
      this.setCustomColumn(data)
      this.isHighlight = true
    },
    stepperClickedUp(id) {
      this.sortChanged = true
      this.showSpin = null
      this.setCustomColumn({
        name: 'sort',
        value: id,
        direction: 'up',
        view: this.view,
      })
      this.showSpin = null
      this.isHighlight = true
    },
    stepperClickedDown(id) {
      this.sortChanged = true
      this.showSpin = null
      this.setCustomColumn({
        name: 'sort',
        value: id,
        direction: 'down',
        view: this.view,
      })
      this.showSpin = null
      this.isHighlight = true
    },
    close() {
      this.isAdd = false
      this.showDelete = false
      this.isHighlight = false
      this.$emit('close')
    },
    confirmCancel() {
      if (this.isHighlight) {
        this.actionCancel = true
      } else {
        this.close()
      }
    },
    async performCancel() {
      this.actionCancel = null
      this.removeView()
      this.isAdd = false
      this.showDelete = false
      this.isHighlight = false
      this.setSelectedView({ name: '' })
      await this.getCustomViews()
      this.$emit('cancel')
    },
    confirmRemove() {
      this.actionRemove = true
    },
    performRemove() {
      this.removeView()
      this.actionRemove = null
    },
    addView() {
      let $this = this
      this.setSelectedView({ name: '' })
      this.isAdd = true
      this.showDelete = false
      this.isHighlight = true
      setTimeout(() => {
        $this.$refs.inputAddView.focus()
      }, 250)
    },
    updateView() {
      let data = {
        action: 'add',
        name: this.view,
      }
      this.updateCustomView(data)
      this.showDelete = true
      this.isHighlight = true
    },
    removeView() {
      let data = {
        action: 'remove',
        name: this.view,
      }
      console.log('Removing View', data)
      this.updateCustomView(data)
      this.isAdd = false
      this.showDelete = false
      this.isHighlight = true
    },
    async performSave(isClose) {
      let data = {
        Name: 'CustomViews',
        Value: JSON.stringify(this.customViews),
      }
      await this.saveCustomViews(data)
      this.isAdd = false
      this.showDelete = false
      this.isHighlight = false
      this.$emit('saved')
      if (isClose) {
        this.close()
      }

      // console.log('Saving', this.customColumns)
      // let data = {
      //   Name: 'custom-columns',
      //   Value: JSON.stringify(this.customColumns),
      // }
      // await this.saveCustomColumns(data)
      // this.isHighlight = false
      // this.$emit('saved')
    },
  },
}
</script>
<style scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-is {
  margin-left: 5px;
}
.custom-table {
  width: auto;
  height: 255px;
  max-height: 255px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
